import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPackageSummary } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchPackageSummary = createAsyncThunk(
  'packageSummary/fetchPackageSummary',
  async ({query = {}}, {rejectWithValue}) => {
    try {
        const response = await getPackageSummary(query);
        return {
            data: response.data,
            query
        }
    } catch (error) {
        return rejectWithValue(error.response?.data || '获取套餐汇总数据失败');
    }
  }
)

const packageSummarySlice = createSlice({
  name: 'packageSummary',
  initialState: defaultState,
  reducers: {
    resetPackageSummaryState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackageSummary.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchPackageSummary.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchPackageSummary.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})

export const { resetPackageSummaryState } = packageSummarySlice.actions;
export default packageSummarySlice.reducer;